export default "__VITE_ASSET__qn$HR$2v__"